module.exports = __webpack_public_path__ + "static/media/eksjovapen.ad3ae7f8.png";